import { v7 as _v7 } from "uuid";
import { DEFAULT_TIMEZONE } from "@/config/constants";

export function uuid(): string {
  return crypto.randomUUID();
}

export function uuidv7(): string {
  return _v7();
}

export function now(): string {
  return new Date().toISOString();
}

export function todayStr(): string {
  return new Date().toISOString().slice(0, 10);
}

export function generateInviteCode(): string {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  const array = new Uint8Array(8);
  crypto.getRandomValues(array);
  let code = "";
  for (let i = 0; i < 8; i++) code += chars[array[i] % chars.length];
  return code;
}

export function extractMentions(body: string): string[] {
  const matches = body.match(/@([a-zA-Z0-9_]+)/g);
  if (!matches) return [];
  return matches.map((m) => m.slice(1));
}

export function isCompetitionEnded(endsAt: string, timezone?: string): boolean {
  return endsAt < todayInTimezone(timezone ?? DEFAULT_TIMEZONE);
}

export function isEndedMoreThanDaysAgo(endsAt: string, days: number, timezone?: string): boolean {
  const today = todayInTimezone(timezone ?? DEFAULT_TIMEZONE);
  const cutoff = new Date(today);
  cutoff.setDate(cutoff.getDate() - days);
  const cutoffStr = cutoff.toISOString().slice(0, 10);
  return endsAt < cutoffStr;
}

export function validateUsername(username: string): string | null {
  if (username.length < 3 || username.length > 30) {
    return "Username must be 3-30 characters";
  }
  if (!/^[a-zA-Z0-9_]+$/.test(username)) {
    return "Username can only contain letters, numbers, and underscores";
  }
  return null;
}

export function htmlEscape(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function todayInTimezone(timezone: string): string {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts();
  const get = (type: string) => parts.find((p) => p.type === type)?.value ?? "01";
  return `${get("year")}-${get("month")}-${get("day")}`;
}
